export { AdminCatalogComponent as CatalogComponent } from './catalog/admin-catalog.component';
export { AdminLocationComponent as LocationComponent } from './location/admin-location.component';
export { AdminSubCatalogComponent as SubCatalogComponent } from './subcatalog/admin-subcatalog.component';
